/**
 * Services Data - What Braian Offers
 * Professional services and expertise areas
 */

export const services = [
  {
    id: 1,
    title: "Full-Stack Development",
    icon: "◈",
    description: "End-to-end web applications with Symfony backend and Vue/React frontend. From database design to responsive UI.",
    details: [
      "Symfony + Doctrine backend architecture",
      "Vue.js / React frontend development",
      "RESTful API design and implementation",
      "Database modeling and optimization",
      "Authentication & authorization (OAuth2, JWT)",
      "Payment gateway integrations"
    ],
    technologies: ["Symfony", "Vue.js", "React", "PostgreSQL", "MySQL", "REST APIs"],
    pricing: "Project-based or Hourly",
    color: "var(--color-accent)"
  },

  {
    id: 2,
    title: "DevOps & Infrastructure",
    icon: "◉",
    description: "Server setup, Docker containerization, CI/CD pipelines, and cloud architecture for scalable deployments.",
    details: [
      "Docker containerization and orchestration",
      "Nginx configuration and optimization",
      "SSL/TLS setup and multi-domain management",
      "CI/CD pipeline implementation",
      "Server provisioning (Ubuntu/Debian)",
      "Monitoring and alerting setup",
      "Backup and disaster recovery"
    ],
    technologies: ["Docker", "Nginx", "Linux", "CI/CD", "PM2", "MinIO/S3"],
    pricing: "Consulting or Retainer",
    color: "var(--color-accent-alt)"
  },

  {
    id: 3,
    title: "System Optimization",
    icon: "◎",
    description: "Performance audits, database optimization, query tuning, and scaling solutions for growing applications.",
    details: [
      "Database query optimization",
      "Caching strategy (Redis, Memcached)",
      "API response time improvements",
      "Load testing and bottleneck identification",
      "Code profiling and refactoring",
      "Infrastructure scaling recommendations"
    ],
    technologies: ["Redis", "Database Tuning", "Profiling Tools", "Load Testing"],
    pricing: "Audit + Implementation",
    color: "var(--color-accent)"
  },

  {
    id: 4,
    title: "Legacy Modernization",
    icon: "◇",
    description: "Migrating outdated systems to modern, maintainable architectures without disrupting business operations.",
    details: [
      "Assessment of legacy codebase",
      "Migration strategy and planning",
      "Gradual refactoring approach",
      "Docker containerization of legacy apps",
      "Zero-downtime migration execution",
      "Documentation and knowledge transfer"
    ],
    technologies: ["Docker", "Migration Scripts", "Various Legacy Stacks"],
    pricing: "Project-based",
    color: "var(--color-accent-alt)"
  },

  {
    id: 5,
    title: "Technical Leadership & CTO Services",
    icon: "◐",
    description: "Strategic technology planning, team leadership, architectural decisions, and technical roadmap development.",
    details: [
      "Technology strategy and roadmap",
      "Architecture design and review",
      "Team building and mentorship",
      "Code review and quality standards",
      "Vendor and tool evaluation",
      "Security and compliance oversight",
      "Budget planning and optimization"
    ],
    technologies: ["Leadership", "Strategy", "Architecture", "Team Management"],
    pricing: "Part-time or Fractional CTO",
    color: "var(--color-accent)"
  },

  {
    id: 6,
    title: "API Development & Integration",
    icon: "◒",
    description: "Design and implementation of robust APIs, third-party integrations, and microservices architecture.",
    details: [
      "RESTful API design",
      "GraphQL implementation",
      "Third-party API integrations",
      "Webhook systems",
      "API documentation (OpenAPI/Swagger)",
      "Rate limiting and security",
      "Microservices architecture"
    ],
    technologies: ["REST", "GraphQL", "OAuth2", "Microservices", "RabbitMQ"],
    pricing: "Project-based or Hourly",
    color: "var(--color-accent-alt)"
  }
];

// Service categories
export const serviceCategories = {
  development: ["Full-Stack Development", "API Development & Integration"],
  infrastructure: ["DevOps & Infrastructure", "System Optimization"],
  transformation: ["Legacy Modernization"],
  leadership: ["Technical Leadership & CTO Services"]
};

// Typical engagement models
export const engagementModels = [
  {
    type: "Project-Based",
    description: "Fixed scope and timeline for specific deliverables",
    bestFor: "Defined projects with clear requirements",
    duration: "2-6 months typically"
  },
  {
    type: "Hourly Consulting",
    description: "Flexible hourly engagement for ongoing needs",
    bestFor: "Technical guidance, code reviews, troubleshooting",
    duration: "Ongoing or ad-hoc"
  },
  {
    type: "Monthly Retainer",
    description: "Dedicated hours per month for continuous support",
    bestFor: "Maintenance, optimization, regular feature development",
    duration: "3-12 months"
  },
  {
    type: "Fractional CTO",
    description: "Part-time strategic technology leadership",
    bestFor: "Startups and growing companies needing technical direction",
    duration: "6-24 months"
  }
];

export default services;
